import { DistributorDetailPage } from "../../../Distributor/DistributorDetailPage/DistributorDetailPage";

export const SellerAdminDistributorDetail = () => {
  return <DistributorDetailPage />;
};
